import { render, staticRenderFns } from "./DealersListAddNew.vue?vue&type=template&id=b04bca24&"
import script from "./DealersListAddNew.vue?vue&type=script&lang=js&"
export * from "./DealersListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./DealersListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports